
export class EntityIdBase{
    Id: number = 0;
}